const getters = {
  getRangeValues: (state) => (attribute) => {
    if (state.ranges != null) {
      const range = state.ranges[attribute]
      if (range != null) {
        return { from: range.from, to: range.to }
      }
    }
    return null
  },
  getRangeLimits: (state) => (attribute) => {
    if (state.ranges != null) {
      const range = state.ranges[attribute]
      if (range != null) {
        return { from: range.limitFrom, to: range.limitTo }
      }
    }
    return null
  },
  getRangeValuesQuery: (state) => {
    if (state.ranges != null) {
      return Object.keys(state.ranges).map((key) => {
        return {
          type: key,
          from: state.ranges[key].from,
          to: state.ranges[key].to
        }
      })
      .filter(({ from, to }) => {
        return from != null && to != null
      })
    }
    return []
  },
  getRangeValuesCurrentFilters: (state) => {
    if (state.ranges != null) {
      return Object.keys(state.ranges).map((key) => {
        return {
          type: key,
          from: state.ranges[key].from,
          to: state.ranges[key].to
        }
      }).filter(({ from, to }) => {
        return from != null && to != null
      })
    }
    return []
  },
  getRangeValuesURL: (state) => {
    let queryURL = {}
    if (state.ranges != null) {
      const ranges =  Object.keys(state.ranges).map((key) => {
        let string = []
        if (state.ranges[key].from != null) {
          string.push(state.ranges[key].from)
        }
        if (state.ranges[key].to != null) {
          string.push(state.ranges[key].to)
        }
        return {
          type: key,
          string
        }
      })
      ranges.forEach((range, index) => {
        if (range.string.length > 0) {
          queryURL[`rangeFilters=${range.type}`] = (range.string.map((value) => value).join('~'))
        }
      })
      return queryURL
    }
    return null
  }
}

export default getters
